import * as React from "react";
import { Trans } from "react-i18next";
import { BalanceUpdateExperienceDetailsFragmentFragment } from "../../../hooks/useTransactions/graphql/TransactionsFragment.generated";

export const BalanceUpdateExperienceDetails = ({
  details,
}: {
  details: BalanceUpdateExperienceDetailsFragmentFragment;
}) => {
  return (
    <div>
      <Trans
        i18nKey="transaction.BalanceUpdateExperienceDetails_details"
        values={{
          achievedLevel: details.achievedLevel,
          experiencePoints: details.experiencePoints,
        }}
        components={{
          achievedLevel: <span style={{ color: "#FFFFFF" }} />,
          experiencePoints: <span style={{ color: "#FFFFFF" }} />,
        }}
      />
    </div>
  );
};
